import React, { useState } from "react";
import styled from "styled-components";
import { colors, mediaQueries } from "../theme";
import {
  CardFooter,
  CardSubtitle,
  CardText,
  Col,
  Container,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import CurrencyConverter from "../utils/CurrencyConverter";
import Pagination from "../Pagination";
import { getTheMostAttractivePrice } from "../homepage/Home";
import { Main } from "../Layout";

const ImageWrapper = styled.div`
  width: 100%;
  img {
    width: 100%;
    height: 160px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  }
  ${mediaQueries.desktop} {
    img {
      width: 100%;
      height: 220px;
    }
  }
`;

const Price = styled.span`
  margin-top: 5px;
  background-color: ${({ theme }) => theme.primaryOne};
  color: white;
  padding: 2px 10px;
  border-radius: 15px;
  font-weight: 600;
`;

const CelebrityList = ({ celebrities, isEuro }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 30;
  const totalPages = Math.ceil(celebrities.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const itemsToDisplay = celebrities?.slice(startIndex, endIndex);

  const onNextClick = (page) => {
    if (page < totalPages) {
      setCurrentPage(page + 1);
    }
  };
  const onPreviousClick = (page) => {
    if (page > 1) {
      setCurrentPage(page - 1);
    }
  };

  return (
    <Main fluid>
      {itemsToDisplay.length > 0 ? (
        <Row>
          {itemsToDisplay.map((c, index) => (
            <Col key={index} xs={6} sm={4} md={3} lg={2} className={"my-3"}>
              <Link
                to={`/shop/${c.id}/infos`}
                state={{ celebrity: c, currency: isEuro ? "euro" : "cfa" }}
                className={"text-decoration-none"}
              >
                <ImageWrapper>
                  <img
                    src={c.avatar}
                    title={`photo de ${c.givenName} ${c.familyName}`}
                    alt={`photo de ${c.givenName} ${c.familyName}`}
                    className={"object-fit-cover rounded-top"}
                  />
                </ImageWrapper>

                <CardFooter className={"pt-1 pb-2 rounded-bottom"}>
                  <CardText
                    tag={"div"}
                    className={"fw-bold text-center text-capitalize"}
                  >
                    {`${c.givenName} ${c.familyName.toUpperCase()}`}
                  </CardText>
                  <CardSubtitle
                    tag={"div"}
                    className={"text-center text-capitalize"}
                  >
                    {c.title}
                  </CardSubtitle>
                  <CardText
                    className={
                      "d-flex justify-content-around align-items-baseline"
                    }
                  >
                    <Price>
                      {CurrencyConverter(
                        getTheMostAttractivePrice(c),
                        c.products.find(
                          (p) => p.price === getTheMostAttractivePrice(c)
                        ).currency,
                        isEuro ? "euro" : "cfa"
                      )}
                    </Price>
                  </CardText>
                </CardFooter>
              </Link>
            </Col>
          ))}
        </Row>
      ) : (
        <p className={"fs-4 py-4"}>
          Aucune données disponible sur les célébrités pour le moment.
        </p>
      )}

      {totalPages > 1 && (
        <Row className={"my-4"}>
          <Col className={"d-flex justify-content-center"}>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onNextClick={onNextClick}
              onPreviousClick={onPreviousClick}
            />
          </Col>
        </Row>
      )}
    </Main>
  );
};

export default CelebrityList;
